import { useCallback } from 'react'
import { ToolBarButton } from 'components/ToolBarButton'
import DispensingDecisionModal from 'modals/DispensingDecisionModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { GitBranch } from 'react-feather'
import type { SideToolBarProps } from 'types'

export const DispensingLogicButton = ({ prescription, fillId }: Partial<SideToolBarProps>) => {
  const { showModal } = useModalContext()
  const showDispensingDecision = useCallback(() => {
    if (prescription && fillId) {
      showModal(() => <DispensingDecisionModal prescription={prescription} fillId={fillId} />)
    }
  }, [showModal, prescription, fillId])

  return (
    <ToolBarButton
      icon={GitBranch}
      label="DISPENSING LOGIC"
      tooltipText="DISPENSING LOGIC"
      clickCallback={showDispensingDecision}
    />
  )
}
